(function () {

  // ── 1. FILTRO DROPDOWN PREDITTIVO ──────────────────────────────────────
  function filterPredictive() {
    const searchInput =
      document.querySelector('search-drawer input[name="q"]') ||
      document.querySelector('input[name="q"]');
    if (!searchInput) return;

    const searchTerm = searchInput.value.toLowerCase().trim();
    if (!searchTerm) return;

    const productItems = document.querySelectorAll(
      'search-drawer a[href*="/products/"]'
    );
    if (productItems.length === 0) return;

    let hasVendorMatch = false;
    const matchMap = new Map();

    productItems.forEach((item) => {
      const title = item.textContent.toLowerCase();
      const matches = title.includes(searchTerm);
      matchMap.set(item, matches);
      if (matches) hasVendorMatch = true;
    });

    if (hasVendorMatch) {
      matchMap.forEach((matches, item) => {
        item.style.display = matches ? '' : 'none';
      });
    } else {
      matchMap.forEach((_, item) => {
        item.style.display = '';
      });
    }
  }

  const observer = new MutationObserver(() => setTimeout(filterPredictive, 50));
  observer.observe(document.body, { childList: true, subtree: true });


  // ── 2. REDIRECT CON VENDOR ESATTO DALLA PREDICTIVE SEARCH API ──────────
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action="/search"]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;

    const existingVendor = form.querySelector('input[name="filter.p.vendor"]');
    if (existingVendor) return;

    e.preventDefault();

    const q = input.value.trim();

    fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
      .then(res => res.json())
      .then(data => {
        const products = data?.resources?.results?.products || [];

        // ← unica modifica: includes invece di ===
        const matchingProduct = products.find(p =>
          p.vendor && p.vendor.toLowerCase().includes(q.toLowerCase())
        );

        let url;
        if (matchingProduct) {
          url = `/search?q=${encodeURIComponent(q)}&type=product&filter.p.vendor=${encodeURIComponent(matchingProduct.vendor)}`;
        } else {
          url = `/search?q=${encodeURIComponent(q)}&type=product`;
        }

        window.location.href = url;
      })
      .catch(() => {
        window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      });
  });

})();
